import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Verein } from "../../types"
import "./HomePage.css";


export default function HomePage() {
  const [vereine, setVereine] = useState<Verein[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function loadVereine() {
      try {
        const res = await fetch("/.netlify/functions/get-vereine");
        const json = await res.json();

        if (json.error) {
          throw new Error(json.error);
        }

        setVereine(json.data || []);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    loadVereine();
  }, []);

  return (
    <div className="homepage">
      <header className="homepage-header">
        <h1>Tischtennis Spielplan App</h1>
        <p>Lade die Spielpläne der Mannschaften deines Vereins</p>
      </header>

      <main className="homepage-main">
        {loading && <p>Lade Vereine…</p>}
        {error && <p style={{ color: "red" }}>Fehler: {error}</p>}

        {!loading && !error && (
          <>
            <p>Wähle deinen Verein:</p>

            <ul className="homepage-verein-list">
              {vereine.map((verein) => (
                <li key={verein.VereinsId}>
                  <Link
                    to={`/verein/${verein.Slug}`}
                    className="homepage-link"
                  >
                    👉 Zum Vereinskalender von {verein.Name}
                  </Link>
                </li>
              ))}
            </ul>
          </>
        )}
      </main>

      <footer className="homepage-footer">
        <small>&copy; {new Date().getFullYear()}</small>
      </footer>
    </div>
  );
}
